@import '../Field/field.css';

/**
 * @prop --field-grid-columns: The field layout.
 **/

:host {
    display: block;
}

.input {
    height: 40px;
    border-radius: 20px;
    grid-column-start: input;
    grid-column-end: input;

    border-width: 1px;
    border-style: solid;
    border-color: var(--color-shade-60);
    outline: none;
    padding: 0 20px;
    transition-property: border-color;
    transition-duration: 500ms;
    transition-timing-function: ease;

    font-family: 'MuseoSans', Arial, sans-serif;
    font-weight: 400;
    font-size: 16px;
    color: var(--color-text);
    background-color: var(--color-background);

    &:disabled {
        color: var(--color-disabled-contrast);
        border-color: var(--color-disabled-border);
        background-color: var(--color-disabled);
        border-style: dashed;
    }

    &:focus {
        border-color: var(--color-secondary);
    }

    &::placeholder {
        color: var(--color-shade-60);
    }
}

.invalid {
    & .input {
        border-color: var(--color-error);
    }
}

::slotted(*) {
    grid-column-start: after;
    grid-column-end: after;
}
